export default __webpack_public_path__ + "static/media/interview_insights_full.d143f8f5.svg";